import { State, Selector, Action, StateContext } from '@ngxs/store';
import { INI } from '../../models/WbidINI';
import { AddINI, RemoveINI } from '../actions/ini.action';

export class INIStateModel {
  ini: INI;
}

@State({
  name: 'ini',
  defaults: {
    ini: [],
  },
})
export class INIState {
  @Selector()
  static getINI(state: INIStateModel) {
    return state.ini;
  }

  @Action(AddINI)
  add(
    { getState, patchState }: StateContext<INIStateModel>,
    { payload }: AddINI
  ) {
    patchState({ ini: payload });
  }

  @Action(RemoveINI)
  remove({ patchState }: StateContext<INIStateModel>) {
    patchState({ ini: undefined });
  }
}
